module.exports = __webpack_public_path__ + "img/product-landscape-cocoa-ball-x1.e7efde24.jpg";